/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';

/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

import { useState } from 'react';

import { useDispatch, useSelect, select } from '@wordpress/data';

import { insertBlock } from '@wordpress/block-editor';
import { createBlock } from '@wordpress/blocks';
/**
 * Options
 */
import { writingStyles, languages } from './options';
/**
 * Icons
 */
import icons from './icons.js';
import toolbaricons from './toolbar.icons.js';
import MoMoToolbar from './momo.toolbarmenu';

const { Fragment } = wp.element;
const { RichText, BlockControls } = wp.blockEditor;
const { ToolbarGroup, DropdownMenu, Spinner, MenuGroup, MenuItem } = wp.components;
const { addFilter } = wp.hooks;

addFilter('editor.BlockEdit', 'momo-acg-forms/momo-form-toolbar', (BlockEdit) => {
    return (props) => {

        const [selectedOption, setSelectedOption] = useState('Informative');
        const [isFetching, setFetching] = useState(false);
        /* const [isPopoverVisible, setIsPopoverVisible] = useState(false);
        const [ popoverAnchor, setPopoverAnchor ] = useState(); */
        const { name, isSelected, clientId } = props;
        const emptyBlock = __('Paragraph seems to be empty. Please fill some text first.', 'momoacg');
        const handleCreateAIHelper = () => {
            const selectedBlockIndex = wp.data.select('core/block-editor').getBlockIndex(clientId);
            const customBlock = createBlock('momothemes/momo-ai-helper-pro', {});
            var blockList = wp.data.select('core/block-editor').getBlocks();
            var updatedBlockList = [...blockList];
            updatedBlockList.splice(selectedBlockIndex, 0, customBlock);
            wp.data.dispatch('core/block-editor').resetBlocks(updatedBlockList);
            const customClientID = customBlock.clientId;
            wp.data.dispatch('core/block-editor').selectBlock(customClientID);
        }
        const handleMenuItemClicked = (type, value = '') => {
            const paragraphBlock = wp.data.select('core/block-editor').getBlock(clientId);
            const {attributes} = paragraphBlock;
            const {content} = attributes;
            if (content.trim() === '') {
                alert(emptyBlock);
                return;
            } else {
                const paragraphElement = document.querySelector(`p.wp-block[data-block="${clientId}"]`);
                if (paragraphElement) {
                    const range = document.createRange();
                    range.selectNode(paragraphElement);

                    const selection = window.getSelection();
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
                setFetching(true);
                fetch( momo_forms_script.rest_toolbar, {
                    method: 'POST',
                    body: JSON.stringify({ content: content, type: type, value: value }),
                    headers: {
                      'Content-Type': 'application/json'
                    }
                })
                .then(response => response.json())
                .then(data => {
                    // Handle the API response data
                    console.log(data);
                    // Update the content of the existing paragraph block
                    wp.data.dispatch('core/block-editor').updateBlock(clientId, {
                        attributes: {
                        content: data.message // Replace with the actual property containing the response text
                        }
                    });
                    setFetching(false);

                })
                .catch(error => {
                    // Handle any error that occurs during the API call
                    console.error(error);
                    setFetching(false);
                });
            }
        }
        const dispatch = useDispatch();

        const addHeaderBlock = () => {
            const { createBlock } = wp.blocks;
            const data = window.wp.data;

            const selectedBlockIndex = wp.data.select('core/block-editor').getBlockIndex(clientId);
            if (selectedBlockIndex !== null) {
                const paragraphBlock = wp.data.select('core/block-editor').getBlock(clientId);
                const {attributes} = paragraphBlock;
                const {content} = attributes;
                setFetching(true);
                fetch( momo_forms_script.rest_toolbar, {
                    method: 'POST',
                    body: JSON.stringify({ content: content, type: 'write_title' }),
                    headers: {
                      'Content-Type': 'application/json'
                    }
                })
                .then(response => response.json())
                .then(data => {
                    const headerBlock = createBlock( 'core/heading',
                        {
                            level: 3,
                            content: data.message
                        }
                    );
                    const insertIndex = selectedBlockIndex > 0 ? selectedBlockIndex : 0;
                    var blockList = wp.data.select('core/block-editor').getBlocks();
                    var updatedBlockList = [...blockList];
                    updatedBlockList.splice(selectedBlockIndex, 0, headerBlock);
                    wp.data.dispatch('core/block-editor').resetBlocks(updatedBlockList);
                    const headerClientID = headerBlock.clientID;
                    wp.data.dispatch('core/block-editor').selectBlock(headerClientID);
                    setFetching(false);

                })
                .catch(error => {
                    // Handle any error that occurs during the API call
                    console.error(error);
                    setFetching(false);
                });
            }
        };
        if (name === 'core/paragraph' && isSelected) {
            return (
                <Fragment>
                    <BlockEdit {...props} />
                    <BlockControls>
                        <ToolbarGroup
                            className='momo-toolbar-group'
                        >
                            <DropdownMenu
                                className="momo-toolbar-dropdown"
                                icon={icons.logo}
                                label={__('MoMo Toolbar', 'momoacg')}
                                controls={[
                                    {
                                        title: __('Ask AI Helper','momoacg'),
                                        icon: icons.logo,
                                        onClick: () => {
                                            // Handle submenu 1 click event
                                            handleCreateAIHelper();
                                        },
                                    },
                                    {
                                        title: __('Spelling and Grammer','momoacg'),
                                        icon: toolbaricons.spelling,
                                        onClick: () => {
                                            // Handle submenu 1 click event
                                            handleMenuItemClicked('spellingandgrammer');
                                        },
                                    },
                                    {
                                        title: __('Summarize','momoacg'),
                                        icon: toolbaricons.summarize,
                                        onClick: () => {
                                            // Handle submenu 1 click event
                                            handleMenuItemClicked('summarize');
                                        },
                                    },
                                    {
                                        title: __('Paraphrasing', 'momoacg'),
                                        icon: toolbaricons.paraphraze,
                                        onClick: () => {
                                            // Handle submenu 2 click event
                                            handleMenuItemClicked('paraphrase');
                                        },
                                    },
                                    {
                                        title: __('Rewriting', 'momoacg'),
                                        icon: toolbaricons.rewrite,
                                        onClick: () => {
                                            // Handle submenu 2 click event
                                            handleMenuItemClicked('rewrite');
                                        },
                                    },
                                    {
                                        title: __('Write a title', 'momoacg'),
                                        icon: toolbaricons.title,
                                        onClick: () => {
                                            addHeaderBlock()
                                        },
                                    },
                                ]}
                            />
                            <DropdownMenu
                                className="momo-toolbar-dropdown"
                                icon={icons.globe}
                                label={__('Translate', 'momoacg')}
                                controls={
                                    languages.map((language) => ({
                                        title: language.title,
                                        onClick: () => handleMenuItemClicked('language', language.value),
                                        isActive: selectedOption === language.value,
                                    }))
                                }
                            />
                            <DropdownMenu
                                className="momo-toolbar-dropdown"
                                icon={icons.tone}
                                label={__('Writing Style', 'momoacg')}
                                controls={
                                    writingStyles.map((tone) => ({
                                        title: tone.title,
                                        onClick: () => handleMenuItemClicked('tone', tone.value),
                                        isActive: selectedOption === tone.value,
                                    }))
                                }
                            />
                            {isFetching && (
                                <Spinner/>
                            )}
                        </ToolbarGroup>
                    </BlockControls>
                </Fragment>
            );
        }

        return <BlockEdit {...props} />;
    };
});
